
// 上传文件通用接口
var upload_common = function(option, floder_name){
      
    let p_file = option.file
    let l_file_type = p_file.type
    let b_is_image = l_file_type.indexOf("image") != -1

    // 是否图片
    if (!b_is_image) {
      this.$message.error("只能上传图片格式png、jpg");
      return
    }

    // form 表单
    let d_form_data = new FormData()

    d_form_data.append("file", p_file)
    d_form_data.append('folder', floder_name)
    let url= '/api/upload_file/'

    let res = this.$axios.post(
        url, d_form_data, {headers: {"content-type": "multipart/form-data"}}
    )
    console.log(res)
    console.log(res.data)
    return res
  }

export default upload_common



